module.exports = __webpack_public_path__ + "img/contributions20Off.540ac150.svg";